import React from 'react'

import { useDocumentReportId } from '../useDocumentReportId'

export const useMainQueryKey = () => {
  const documentReportId = useDocumentReportId()

  return React.useMemo(
    () => ['DocumentReportEditPage_Main', { documentReportId }] as const,
    [documentReportId],
  )
}
